import { render, staticRenderFns } from "./MasterTruckLumpsumEdit.vue?vue&type=template&id=64258767&scoped=true"
import script from "./MasterTruckLumpsumEdit.vue?vue&type=script&lang=js"
export * from "./MasterTruckLumpsumEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64258767",
  null
  
)

export default component.exports